import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { useDispatch } from "react-redux";
import { processRavenPayment } from "../../../../../store/modules/payments";
import {
  ArrowCircle,
  CardPaymentIcon,
  Interswitch,
  KudaIcon,
  MoniepointIcon,
  OpayIcon,
  RavenIcon,
} from "../../../../../assets/svgIcons";
import { useMemo, useState } from "react";
import { RoutedModal } from "../../../../common";
import { CardListener } from "../CardListener";
import { useGetCheckoutPaymentProviders } from "../../../../../hooks/useGetCheckoutPaymentProviders";
import primaryComponents from "../../../../primaryComponents";
import secondaryComponents from "../../..";
import { StoreTerminalSelect } from "../../../IntegratedTerminals";
import { useGetSellmodeAssignedTerminal } from "../../../../../hooks/useGetSellmodeAssignedTerminal";
import { formatCurrency } from "../../../../../helpers";

export const PaymentViaCardPrompt = ({
  amount = "",
  closeModal = () => {},
  chargeOutsideApp = () => {},
}) => {
  const dispatch = useDispatch();
  const [terminalProvider, setTerminalProvider] = useState(null);
  const { allowedPaymentProviders } = useGetCheckoutPaymentProviders();

  const {
    assignTerminalProviders,
    isFetchingTerminals,
    terminals,
    assignedTerminal,
    setAssignedTerminal,
  } = useGetSellmodeAssignedTerminal({
    isFetchTerminals: true,
    paymentProvider: terminalProvider,
  });

  const moniePointTerminals = useMemo(() => {
    const moniePointTerminals = [...terminals];
    return moniePointTerminals.filter(
      (terminal) => terminal?.terminal_type === "MONIEPOINT",
    );
  }, [terminals]);

  const interswitchTerminals = useMemo(() => {
    const interswitchTerminals = [...terminals];
    return interswitchTerminals.filter(
      (terminal) => terminal?.terminal_type === "INTERSWITCH",
    );
  }, [terminals]);

  const opayTerminals = useMemo(() => {
    const opayTerminals = [...terminals];
    return opayTerminals.filter(
      (terminal) => terminal?.terminal_type === "OPAY",
    );
  }, [terminals]);

  const kudaTerminals = useMemo(() => {
    const kudaTerminals = [...terminals];
    return kudaTerminals.filter(
      (terminal) => terminal?.terminal_type === "KUDA",
    );
  }, [terminals]);

  // const kudaProcessingFee = useMemo(() => {
  //   let fee =
  //     (Number(kudaTerminals?.[0]?.lumi_processing_fee_rate) * Number(amount)) /
  //     100;

  //   return fee > Number(kudaTerminals?.[0]?.lumi_processing_fee_cap)
  //     ? Number(kudaTerminals?.[0]?.lumi_processing_fee_cap)
  //     : fee;
  // }, [amount]);

  return (
    <>
      <div>
        <secondaryComponents.LoaderHelper
          isLoading={isFetchingTerminals}
          classNames={"mt-5"}
        >
          {allowedPaymentProviders?.includes("opay") && (
            <div className={`${globalStyles.cardWithBorder} mb-3`}>
              <div
                className="d-flex justify-content-between"
                style={{ gap: "50px" }}
              >
                <div
                  className="d-flex justify-content-center"
                  style={{ gap: "10px" }}
                >
                  <OpayIcon />

                  <div>
                    <h6 className="mb-0">Use Opay POS</h6>
                    <p className="small-text-size">
                      Process payments via Opay. Payments are reconciled to your
                      sales.
                    </p>
                  </div>
                </div>

                {opayTerminals?.length > 0 ? (
                  <>
                    {/* <div className="d-flex" style={{ gap: "10px" }}> */}
                    <primaryComponents.Button
                      classNames={"btn btn--primary"}
                      style={{ width: "100%", maxWidth: "270px" }}
                      onClick={() => {
                        const providerName = "OPAY";
                        const terminalDetails =
                          assignTerminalProviders?.[providerName];

                        chargeOutsideApp({
                          isPendPayment: true,
                          gateway: providerName,
                          terminal_sn: terminalDetails?.terminal_sn,
                        });
                        closeModal();
                      }}
                    >
                      Charge (
                      {formatCurrency({
                        value: Number(amount),
                      })}
                      )
                    </primaryComponents.Button>
                    {/* <primaryComponents.Button
                      classNames={"btn btn--primary"}
                      style={{ width: "100%", maxWidth: "270px" }}
                      onClick={() => {
                        setTerminalProvider("OPAY");
                      }}
                    >
                      Charge (
                      {formatCurrency({
                        value: Number(amount),
                      })}
                      )
                    </primaryComponents.Button> */}
                    {/* </div> */}
                  </>
                ) : (
                  <primaryComponents.Button
                    classNames={"btn btn--primary"}
                    style={{ width: "100%", maxWidth: "270px" }}
                    onClick={() =>
                      window.open(
                        "https://enlumidatainc.zohodesk.com/portal/en/kb/articles/opay-pos-integration-guide-for-lumi-business#22_An_OPay_POS_Terminal",
                      )
                    }
                  >
                    Setup
                  </primaryComponents.Button>
                )}
              </div>

              <StoreTerminalSelect
                terminalList={opayTerminals}
                terminal_type={"OPAY"}
                assignedTerminal={assignedTerminal}
                setAssignedTerminal={setAssignedTerminal}
              />
            </div>
          )}

          {allowedPaymentProviders?.includes("interswitch") && (
            <div className={`${globalStyles.cardWithBorder} mb-3`}>
              <div
                className="d-flex justify-content-between"
                style={{ gap: "50px" }}
              >
                <div
                  className="d-flex justify-content-center"
                  style={{ gap: "10px" }}
                >
                  <Interswitch />

                  <div>
                    <h6 className="mb-0">Use Interswitch SmartPOS</h6>
                    <p className="small-text-size">
                      Process payments via interswitch. Payments are reconciled
                      to your sales.
                    </p>
                  </div>
                </div>

                {interswitchTerminals?.length > 0 ? (
                  <primaryComponents.Button
                    classNames={"btn btn--primary"}
                    style={{ width: "100%", maxWidth: "270px" }}
                    onClick={() => {
                      const providerName = "INTERSWITCH";
                      const terminalDetails =
                        assignTerminalProviders?.[providerName];

                      chargeOutsideApp({
                        isPendPayment: true,
                        gateway: providerName,
                        terminal_sn: terminalDetails?.terminal_sn,
                      });
                      closeModal();
                    }}
                  >
                    Charge (
                    {formatCurrency({
                      value: Number(amount),
                    })}
                    )
                  </primaryComponents.Button>
                ) : (
                  <primaryComponents.Button
                    classNames={"btn btn--primary"}
                    style={{ width: "100%", maxWidth: "270px" }}
                    onClick={() =>
                      window.open(
                        "https://enlumidatainc.zohodesk.com/portal/en/kb/articles/integration-guide-lumi-business-inventory-point-of-sale-with-interswitch-pos",
                      )
                    }
                  >
                    Setup
                  </primaryComponents.Button>
                )}
              </div>

              <StoreTerminalSelect
                terminalList={interswitchTerminals}
                terminal_type={"INTERSWITCH"}
                assignedTerminal={assignedTerminal}
                setAssignedTerminal={setAssignedTerminal}
              />
            </div>
          )}

          {allowedPaymentProviders?.includes("kuda") && (
            <div className={`${globalStyles.cardWithBorder} mb-3`}>
              <div
                className="d-flex justify-content-between"
                style={{ gap: "50px" }}
              >
                <div
                  className="d-flex justify-content-center"
                  style={{ gap: "10px" }}
                >
                  <KudaIcon />

                  <div>
                    <h6 className="mb-0"> Use Kuda POS </h6>
                    <p className="small-text-size">
                      Process payments via Kuda. Payments are reconciled to your
                      sales.
                    </p>
                  </div>
                </div>

                {kudaTerminals?.length > 0 ? (
                  <primaryComponents.Button
                    classNames={"btn btn--primary"}
                    style={{ width: "100%", maxWidth: "270px" }}
                    onClick={() => {
                      setTerminalProvider("KUDA");
                    }}
                  >
                    {/* <ArrowCircle width="20" height="20" className="mr-2" /> */}
                    Charge (
                    {formatCurrency({
                      value: Number(amount),
                    })}
                    )
                  </primaryComponents.Button>
                ) : (
                  <primaryComponents.Button
                    classNames={"btn btn--primary"}
                    style={{ width: "100%", maxWidth: "270px" }}
                    onClick={() =>
                      window.open(
                        "https://enlumidatainc.zohodesk.com/portal/en/kb/articles/opay-pos-integration-guide-for-lumi-business#22_An_OPay_POS_Terminal",
                      )
                    }
                  >
                    Setup
                  </primaryComponents.Button>
                )}
              </div>

              <StoreTerminalSelect
                terminalList={kudaTerminals}
                terminal_type={"KUDA"}
                assignedTerminal={assignedTerminal}
                setAssignedTerminal={setAssignedTerminal}
              />
            </div>
          )}

          {allowedPaymentProviders?.includes("raven") && (
            <div className={`${globalStyles.cardWithBorder} mb-3`}>
              <div
                className="d-flex justify-content-between"
                style={{ gap: "50px" }}
              >
                <div
                  className="d-flex justify-content-center"
                  style={{ gap: "10px" }}
                >
                  <RavenIcon />

                  <div>
                    <h6 className="mb-0">Use Raven</h6>
                    <p className="small-text-size">
                      Process payments via raven. Payments are reconciled to
                      your sales.
                    </p>
                  </div>
                </div>

                <primaryComponents.Button
                  classNames={"btn btn--primary"}
                  style={{ width: "100%", maxWidth: "270px" }}
                  onClick={() => {
                    dispatch(
                      processRavenPayment({
                        amount: amount,
                        allowFeedBack: false,
                      }),
                    );
                  }}
                >
                  Charge (
                  {formatCurrency({
                    value: Number(amount),
                  })}
                  )
                </primaryComponents.Button>
              </div>
            </div>
          )}

          {allowedPaymentProviders?.includes("moniepoint") && (
            <div className={`${globalStyles.cardWithBorder} mb-3`}>
              <div
                className="d-flex justify-content-between"
                style={{ gap: "50px" }}
              >
                <div
                  className="d-flex justify-content-center"
                  style={{ gap: "10px" }}
                >
                  <MoniepointIcon />

                  <div>
                    <h6 className="mb-0">Use Moniepoint POS</h6>
                    <p className="small-text-size">
                      Process payments via Moniepoint. Payments are reconciled
                      to your sales.
                    </p>
                  </div>
                </div>

                <primaryComponents.Button
                  classNames={"btn btn--primary"}
                  style={{ width: "100%", maxWidth: "270px" }}
                  onClick={() => {
                    setTerminalProvider("MONIEPOINT");
                  }}
                >
                  Charge (
                  {formatCurrency({
                    value: Number(amount),
                  })}
                  )
                </primaryComponents.Button>
              </div>

              <StoreTerminalSelect
                terminalList={moniePointTerminals}
                terminal_type={"MONIEPOINT"}
                assignedTerminal={assignedTerminal}
                setAssignedTerminal={setAssignedTerminal}
              />
            </div>
          )}

          <div
            className={`${globalStyles.cardWithBorder} cursor-pointer flex-row justify-content-between align-items-center mb-3`}
            onClick={() => {
              chargeOutsideApp();
              closeModal();
            }}
          >
            <div
              className="d-flex justify-content-center"
              style={{ gap: "10px" }}
            >
              <CardPaymentIcon width="40" height="41" />
              <div>
                <h6 className="mb-0">Card payment already collected</h6>
                <p className="small-text-size">
                  If you have already collected the payment before reaching this
                  point choose this option.
                </p>
              </div>
            </div>
            <ArrowCircle stroke="#15112D" width="20" height="20" />
          </div>
        </secondaryComponents.LoaderHelper>
      </div>

      <RoutedModal
        isActive={terminalProvider !== null}
        width={650}
        showHeader={false}
        // headerTitle="Accept Card Payments"
        closeModal={() => setTerminalProvider(null)}
        style={{ height: "auto" }}
      >
        <CardListener
          amount={amount}
          paymentProvider={terminalProvider}
          closeModal={() => setTerminalProvider(null)}
        />
      </RoutedModal>
    </>
  );
};
